@let label = labelSg();
@let typedValue = typedValueSg();

@switch (typedValue.type) {
  @case (IntrinsicEnum.Integer) {
    <atn-ds-number
      [value]="typedValue.value"
      [label]="label"
      (change)="typedValueSg.set({ type: typedValue.type, value: $event })"
    />
  }
  @case (IntrinsicEnum.Decimal) {
    <atn-ds-number
      [value]="typedValue.value"
      [label]="label"
      [type]="typedValue.type"
      (change)="typedValueSg.set({ type: typedValue.type, value: $event })"
    />
  }
  @case (IntrinsicEnum.Percent) {
    <atn-ds-number
      [value]="typedValue.value"
      [label]="label"
      [type]="typedValue.type"
      (change)="typedValueSg.set({ type: typedValue.type, value: $event })"
    />
  }
  @case (IntrinsicEnum.Boolean) {
    <atn-ds-radio-options
      [label]="label"
      (change)="typedValueSg.set({ type: typedValue.type, value: !!$event })"
    >
      <atn-ds-radio-option
        [radioValue]="true"
        name="Yes"
        [isActive]="typedValue.value"
      />
      <atn-ds-radio-option
        [radioValue]="false"
        name="No"
        [isActive]="!typedValue.value"
      />
    </atn-ds-radio-options>
  }
  @case (IntrinsicEnum.Text) {
    <atn-ds-text
      [value]="typedValue.value"
      [label]="label"
      (change)="typedValueSg.set({ type: typedValue.type, value: $event })"
    />
  }
  @case (IntrinsicEnum.Date) {
    <atn-ds-datepicker
      [value]="typedValue.value"
      (valueChange)="typedValueSg.set({ type: typedValue.type, value: $event })"
      [label]="label"
    />
  }
  @case (IntrinsicEnum.DateRange) {
    <atn-ds-date-range-single
      [value]="typedValue.value"
      (valueChange)="typedValueSg.set({ type: typedValue.type, value: $event })"
      [label]="label"
    />
  }

  @case (IntrinsicEnum.DateMultirange) {
    <atn-ds-date-range-multi
      [value]="typedValue.value"
      (valueChange)="typedValueSg.set({ type: typedValue.type, value: $event })"
      [label]="label"
    />
  }

  @case (IntrinsicEnum.Currency) {
    <atn-ds-number
      [value]="typedValue.value"
      [label]="label"
      (change)="typedValueSg.set({ type: typedValue.type, value: $event })"
    />
  }
  @case (IntrinsicEnum.Object) {
    <atn-ds-code
      class="atn-intrinsic-value-input--code"
      [json]="typedValue.value"
      [label]="label"
      (jsonChange)="codeChangeHandler(typedValue.type, $event)"
    />
  }
  @default {
    <b>{{ label }}</b> <br />
    Type
    <span style="font-style: italic"
      ><b>{{ typedValue.type }}</b></span
    >
    not supported.
  }
}
